// Dashboard.js
import React, { useState, useContext, useEffect } from 'react';
import Pal from '../components/Pal';
import infoUpdate from '../serverPostHandling';
import ReactTyped from 'react-typed';
import StepContext from '../Contexts/StepContext';
import { useQuery } from '@tanstack/react-query';
import fetchServerResponse from '../severGetHandling';
import CheckboxOption from '../components/ProfileCompletionComponents/CheckBoxOption';
import { ColorRing } from  'react-loader-spinner'

function Dashboard(props) {
  const { stepCount, incrementStepCount } = useContext(StepContext);
  const [display, setDisplay] = useState(false);
  const [checkboxOptionsSelected, setCheckboxOptionsSelected] = useState([]);

  useEffect(() => {
    setDisplay(false);
  }, [props]);

  const onCheckboxChange = (isChecked, value) => {
    if (isChecked) {
      setCheckboxOptionsSelected([...checkboxOptionsSelected, value]);
    } else {
      setCheckboxOptionsSelected(checkboxOptionsSelected.filter((option) => option !== value));
    }
  };

  const { data: serverGetResponse, isLoading } = useQuery(
    ['serverGetResponse', props.endpoint],
    () => fetchServerResponse(props.endpoint)
  );

  const handleEnter = async (event) => {
    event.preventDefault();
    document.getElementById('onboarding-button').disabled = true;
    if (checkboxOptionsSelected.length === 0) {
      alert('Please choose at least one checkbox option');
      return;
    }
    await infoUpdate("response", props.label, checkboxOptionsSelected);
    const profileResponse = await infoUpdate("response", "profileComplete", "true");
    console.log(profileResponse);
    incrementStepCount();
  };

  const onCompleteHandler = () => {
    setDisplay(true);
  };

  const handleCheckboxOptions = () => {
    return props.option.map((value, index) => (
      <CheckboxOption key={index} value={value} onChangeFunc={onCheckboxChange} />
    ));
  };

  return (
    <div className='form-container'>
      <div className= 'form-card'>
        {isLoading ? (<ColorRing
            visible={true}
            height="80"
            width="80"
            ariaLabel="blocks-loading"
            wrapperStyle={{}}
            wrapperClass="blocks-wrapper"
            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
          />) : (
          <div className='pal-container'>
            <Pal/>
            <ReactTyped strings={[props.altcontent]}
              typeSpeed={20}
              onComplete={onCompleteHandler}/>
          </div>
        )}
        {display && <div id='checkbox-option-container' className='checkbox-options'>
          {handleCheckboxOptions()}
        </div>}
        {display && <button id='onboarding-button' className="form-submit-button" onClick={handleEnter}>Enter</button>}
      </div>
   </div>
  );
}

export default Dashboard;
